import { render } from "./AddView.vue?vue&type=template&id=65f76236"
import script from "./AddView.vue?vue&type=script&lang=js"
export * from "./AddView.vue?vue&type=script&lang=js"

import exportComponent from "/data/gitlab-runner/builds/hunterretail/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__